module.exports = __webpack_public_path__ + "static/img/dy.17167c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/footer/dy.png
// module id = 0iTJ
// module chunks = 3